/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import * as React from 'react';
import { useRef } from 'react';
import { each } from 'lodash';
import { LinkButton, UploadFileFn, UploadEventHandler } from '@blend/enterprise-components';
import { BlendBridge } from 'blb-types/blendBridge';

export namespace UserFileUploader {
  export interface Props extends React.AllHTMLAttributes<HTMLInputElement> {
    acceptFileExts: string;
    fileType: BlendBridge.FileTypes;
    form: any;
    handleUploadEvent: UploadEventHandler;
    linkButtonProps?: Partial<LinkButton.Props>;
    uploadFile: UploadFileFn<{ fileType: BlendBridge.FileTypes }>;
  }
}

export const UserFileUploader: React.FC<UserFileUploader.Props> = ({
  id,
  children,
  fileType,
  handleUploadEvent,
  uploadFile,
  disabled,
  acceptFileExts,
  form,
  linkButtonProps = {},
  ...htmlProps
}) => {
  const fileInputRef = useRef<HTMLInputElement>(null);
  const uploadFiles = (e: React.ChangeEvent<HTMLInputElement>, form: any) => {
    const { files } = e.target;
    each(files, async file => {
      const config = {
        onUploadProgress: () => {},
      };
      const upload = await uploadFile({ config, file, fileType });
      handleUploadEvent(upload.data.id, file, { fileName: file.name, filePath: upload.data.fullPath });
      form.change('fileId', upload.data.key);
    });
    // https://stackoverflow.com/a/12102992/1870047
    fileInputRef.current!.value = null as any;
  };

  return (
    <LinkButton
      disabled={disabled}
      icon="add"
      id={`${id}-input`}
      inputProps={{
        accept: `${acceptFileExts}`,
        disabled,
        onChange: (e: React.ChangeEvent<HTMLInputElement>) => {
          uploadFiles(e, form);
        },
        ref: fileInputRef,
        ...htmlProps,
      }}
      label="Add another document"
      {...linkButtonProps}
    />
  );
};
